import { deliveryteamOrdersApiClient } from '@api-client/deliveryteam_orders';
import { toast } from '@/ui-plus/sonner';
import { myDeliveryteams } from '@deliveryteam-spa-orders-vue/refs/MyDeliveryteams';
import { refreshRecentOrderIds, stopAutoRefreshRecentOrderIds } from '@deliveryteam-spa-orders-vue/refs/RecentOrders';
import { showPhoneValidationForm } from './phoneValidation';
import { showNameForm } from './nameValidation';
import { showIdVerificationForm } from './IdVerification';
import { authState } from "@/ui-plus/useAuth";
import { startRefreshingTokens } from '@api-client/auth/auth';

export const toggleCourierActive = async (deliveryteamId: string, isActive: boolean) => {
    if (!authState.value?.accessTokenPayload?.hasVerifiedPhoneNumber) {
        const result = await showPhoneValidationForm()
        if (result === 1) {
            await startRefreshingTokens();
            toast.success('Phone number verified');
        } else {
            toast.error('Phone number verification failed');
            return;
        }
    }
    if (!authState.value?.accessTokenPayload?.name) {
        const result = await showNameForm()
        if (result === 1) {
            await startRefreshingTokens();
            toast.success('Name saved');
        } else {
            toast.error('Name is required');
            return;
        }
    }
    if (!authState.value?.accessTokenPayload?.hasVerifiedId) {
        const result = await showIdVerificationForm()
        if (result === 1) {
            await startRefreshingTokens();
            toast.success('ID verification successful');
        } else {
            toast.error('ID verification failed');
            return;
        }
    }
    const { error } = await (await deliveryteamOrdersApiClient[':deliveryteamId']['courier_toggle_active'].$post({
        param: { deliveryteamId },
        json: { isActive },
    })).json();

    if (error) {
        if (
            error.code === 'USER_PHONE_NUMBER_NOT_VERIFIED' ||
            error.code === 'USER_ID_NOT_VERIFIED'
        ) {
            await startRefreshingTokens();
            toggleCourierActive(deliveryteamId, isActive);
            return;
        } else {
            toast.error('Failed to toggle active status');
            return;
        }
    }

    const deliveryteam = myDeliveryteams.value.find(team => team.id === deliveryteamId);
    if (deliveryteam) {
        deliveryteam.isUserActivatedTeam = isActive;
    }

    if (isActive) {
        refreshRecentOrderIds(deliveryteamId);
    } else {
        stopAutoRefreshRecentOrderIds(deliveryteamId);
    }
}